import { Drawer, Grid, IconButton } from '@material-ui/core'
import CloseIcon from 'mdi-react/CloseIcon'
import { FC, useState } from 'react'
import { DrawerProps } from '../types'
import MenuItems from './MenuItems'

const NavDrawer: FC<DrawerProps> = ({
  handleToggleDrawer,
  isOpen,
  classes,
  doNavigation,
  navItems,
  currentPathEnd,
  unreadMessages
}) => {
  const [currentKey, setCurrentKey] = useState('')
  return (
    <Drawer
      onClose={handleToggleDrawer}
      anchor='bottom'
      variant='temporary'
      open={isOpen}
      classes={{ paper: classes.drawerPaper }}
    >
      <Grid container justify='space-between' direction='row'>
        <Grid />
        <Grid item>
          <IconButton onClick={handleToggleDrawer}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      <MenuItems
        navigate={doNavigation}
        closeDrawer={handleToggleDrawer}
        menuItems={navItems}
        currentPath={currentPathEnd}
        currentKey={currentKey}
        setCurrentKey={setCurrentKey}
        unreadMessages={unreadMessages}
      />
    </Drawer>
  )
}

export default NavDrawer
